import React from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { useParentAuth } from "../context/ParentAuthContext";
import { useData } from "../context/DataContext";
import { resolveImageUrl } from "../admin/ImageUpload";
import { LogOut, ExternalLink, ShoppingBag } from "lucide-react";

const ParentLayout = () => {
  const { user, logout } = useParentAuth();
  const { settings } = useData();
  const logo = resolveImageUrl(settings?.logo);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cream">
      <header className="bg-white border-b border-stone-100 sticky top-0 z-30">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <Link to="/espace-famille" className="flex items-center gap-3">
            {logo ? (
              <img src={logo} alt="L'Élan Danse" className="h-12 w-auto object-contain" />
            ) : (
              <span className="font-script text-3xl text-deep-rose">L&apos;élan Danse</span>
            )}
            <span className="hidden sm:inline text-xs uppercase tracking-widest text-stone-500">Espace famille</span>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/espace-famille/boutique" data-testid="parent-nav-shop" className="inline-flex items-center gap-1 text-xs text-stone-600 hover:text-deep-rose px-3 py-2"><ShoppingBag size={14}/> <span className="hidden xs:inline sm:inline">Mes commandes</span></Link>
            <Link to="/" className="hidden sm:inline-flex items-center gap-1 text-xs text-stone-600 hover:text-deep-rose px-3 py-2"><ExternalLink size={14}/> Voir le site</Link>
            <button onClick={() => { logout(); navigate("/espace-famille/login"); }} className="inline-flex items-center gap-1 text-xs text-stone-600 hover:text-deep-rose px-3 py-2">
              <LogOut size={14}/> Déconnexion
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default ParentLayout;
